import React from "react";
import { CustomTable } from "../../../shared";

export const ReadUsersList = ({ data = [] }) => {

  const columns = React.useMemo(
    () => [
      {
        Header: "Staff Name",
        accessor: "name",
      },
      {
        Header: "Read On",
        accessor: "read_at",
      },
    ],
    []
  );

  return (
    <CustomTable
      searchBar={false}
      columns={columns}
      data={data}
      defaultSearch={false}
    />
  );
};
